module.exports = {
  "level1": {
    "name": "Nombre real",
    "address": "Dirección residencial actual",
    "bank_number": "Cuenta bancaria",
    "wc": "ACEPTAR",
    "name_nodata": "El nombre no puede estar vacío",
    "id_card_nodata": "El número de documento de indentidad no puede estar vacío",
    "address_nodata": "La dirección no puede estar vacía",
    "bank_number_nodata": "La cuenta bancaria no puede estar vacía",
    "input-username": "Por favor, introduzca su nombre real",
    "zjhm": "Número del documento de indentidad",
    "input-idcard": "Por favor, introduzca el número del documento de indentidad",
    "input-address": "Por favor, introduzca la dirección",
    "zjlx": "Tipos de documentos de indentidad válidos",
    "qxzzjlx": "Seleccione el tipo de documento de identidad",
    "sfz": "documento de indentidad de identidad",
    "hz": "Pasaporte",
    "jsz": "Licencia de conducir",
    "khh": "Abrir cuenta bancaria",
    "qsrkhh": "Por favor ingrese al banco",
    "yhkh": "Cuenta bancaria",
    "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
    "gjlb": "Lista de países",
    "qxzgjlb": "Por favor seleccione País / Región"
  },
  "my": {
    "mqrcode": "Mi código QR",
    "as": "Ajustes",
    "pc": "Certificación junior",
    "ac": "Certificación senior",
    "ms": "Compartir",
    "me": "Mis ingresos",
    "zsr": "Ingresos totales",
    "mp": "Mi promoción",
    "yqhy": "Invitar amigos",
    "ar": "Registros",
    "hc": "Centro de ayuda",
    "nodata": "Sin datos",
    "med": "Desglose de ingresos",
    "aes": "Ingresos acumulados (USDT)",
    "one": "1º gen.     ",
    "two": "2ª gen.",
    "three": "3ª gen.",
    "four": "4ª gen.",
    "ones": "Persona de 1ª gen.",
    "twos": "Persona de 2ª gen.",
    "threes": "Persona de 3ª gen.",
    "fours": "Persona de 4ª gen.",
    "promotion": "Número de promociones",
    "customers": "Mis ingresos",
    "wdzc": "Mis activos",
    "wdzc1": "Mis activos",
    "wyfx": "Compartir",
    "wdsy": "Mis ingresos",
    "wdtg": "Mi promoción",
    "zhjl": "Registros",
    "zxkf": "Contacta con nosotros",
    "wdxx": "Mis mensajes",
    "smrz":"Autenticación KYC",
    "sfyz":"Autenticación KYC",
    "mnzh": "Cuenta demo",

"mnzhcg": "¡Cuenta demo creada correctamente!"
  },
  "footer": {
    "home": "Inicio",
    "quotation": "Mercados",
    "currency": "Intercambio",
    "lever": "Contratos",
    "my": "cuenta",
    "lc": "Intereses ganados en USDDT"
  },
  "index": {
    "wdzc": "Mis activos (USDT)",
    "dl": "iniciar sesión",
    "zxkf": "Contacta con nosotros",
    "increase": "Lista de ganancias",
    "usercenter": "Centro personal",
    "security": "Centro de seguridad",
    "address": "Dirección de retirada de fondos",
    "aboutus": "Sobre nosotros",
    "vol": "Volumen 24H",
    "kjcb": "Depósito",
    "zcbz": "BTC, USDT...",
    "logout":"cerrar sesión",
    "language":"Idioma"
  },
  "transaction": {
    "buy": "Comprar",
    "sell": "Vender",
    "pwd": "Contraseña de transacción",
    "inputnum": "Introducir el importe",
    "limit": "Límite",
    "avaiable": "Disponible",
    "turnover": "Venta",
    "handicap": "Handicap",
    "number": "Importe",
    "nonumber": "Importe pendiente",
    "numbered": "Importe completado",
    "price": "Precio",
    "marketprice": "Precio de mercado",
    "cancel": "Cancelar",
    "time": "Hora",
    "nomore": "No más",
    "nodata": "No hay registro",
    "getmore": "Cargar más",
    "mycommission": "Todas mis ordenes",
    "currentbuy": "Orden actual (Compra)",
    "currentsell": "Orden actual (Venta)    ",
    "his": "Historial de ordenes (Completada)",
    "currency": "Moneda",
    "option": "Operación",
    "wtime": "Tiempo de finalización",
    "wnumber": "Cantidad completada",
    "wprice": "Precio de finalización"
  },
  "mk": {
    "high": "Alto",
    "low": "Bajo",
    "vol": "Volumen 24H",
    "newPrice": "Último precio",
    "product": "Producto",
    "name":"nombre",
    "rank": "Lista de ganancias"
  },
  "deals": {
    "issue_time": "Hora de salida",
    "issue_number": "Número de edición",
    "white_book": "Papel blanco",
    "weburl": "Sitio web oficial",
    "video_url": "Vídeo",
    "introduction": "Información",
    "onhand": "Lote =",
    "position": "Posición",
    "leverorder": "Pedidos apalancados",
    "leverposition": "Posición de apalancados",
    "inputprice": "Precio de entrada",
    "inputmul": "Múltiple de entrada",
    "selectmul": "Elija el múltiplo",
    "onehand": "Lote =",
    "hand": "Lotes de negociación",
    "marketval": "Valor de mercado",
    "bond": "Bono",
    "balance": "Saldo",
    "type": "Tipo",
    "risk": "Tipo de riesgo",
    "total": "Beneficio total",
    "onekey": "Liquidar con un clic",
    "makemore": "(Largo)",
    "makeless": "(Corto)",
    "current": "Ordenes abiertas",
    "all": "Todos",
    "weing": "Ordenes en curso",
    "tding": "En transacción",
    "ping": "Cerrando posición",
    "pied": "Posición cerrada",
    "ceiled": "Retirado",
    "weprice": "Precio de la orden",
    "oprice": "Precio de apertura",
    "nowprice": "Precio actual",
    "zyprice": "Precio de toma de beneficios",
    "zsprice": "Precio stop-loss",
    "canbond": "Margen disponible",
    "optime": "Hora de apertura",
    "pgtime": "Hora de cierre",
    "znum": "Cantidad convertida",
    "gprice": "Cargos nocturnos",
    "pcang": "Cerrar posición",
    "revoke": "Retirar fondos",
    "fee": "Tarifa",
    "you": "Precio óptimo de mercado"
  },
  "assets": {
    "copy": "Copiar",
    "avaiable": "Disponible",
    "lock": "Congelar",
    "conversion": "Conversión",
    "exact": "Cuenta de transacciones",
    "num": "Importe",
    "time": "Hora",
    "all": "Todos",
    "canuse": "Disponible",
    "cmoney": "Depósito",
    "tmoney": "Retirada de fondos",
    "caddress": "Dirección de depósito",
    "copyaddress": "Dirección de copia",
    "taddress": "Dirección de retirada de fondos",
    "taddressm": "Por favor, introduzca la dirección de retiro",
    "rate": "Tarifa",
    "dnum": "Importe a retirar",
    "more": "Cargar más",
    "nodata": "No hay registro",
    "yczc": "Ocultar activos que no tiene",
    "total":"Conversión de activos (USDT)"
  },
  "td": {
    "drecord": "Registro de pedidos",
    "orecord": "Pedidos realizados",
    "filter": "Filtro",
    "dstatus": "Estado del pedido",
    "nofinish": "Se acabó",
    "finished": "Completado",
    "ceiled": "Cancelado",
    "reset": "Reservar",
    "confirm": "ACEPTAR",
    "time": "Hora",
    "num": "Importe",
    "price": "Precio",
    "ptime": "Tiempo de pedido",
    "receiver": "Receptor del pago",
    "open": "Abrir cuenta bancaria",
    "pwd": "Contraseña de transacción",
    "ppwd": "Por favor, introduzca la contraseña de la transacción",
    "sure": "ACEPTAR",
    "realName": "Nombre real",
    "pnum": "Ingrese el importe",
    "buyNum": "Importe de la compra",
    "currency": "Moneda"
  },
  "fat": {
    "ceil": "Cancelar",
    "num": "Importe",
    "submit": "Hacer pedido",
    "pwd": "Contraseña de transacción",
    "ppwd": "Por favor, introduzca la contraseña de la transacción",
    "sure": "Confirmar",
    "auHigh": "Certificación senior"
  },
  "auth": {
    "bh": "Rechazado",
    "mycenter": "Centro personal",
    "test": "KYC",
    "testing": "En revisión",
    "name": "Nombre",
    "account": "Cuenta",
    "id_card_face": "Por favor, suba el anverso del documento de indentidad\n",
    "id_card_back": "Por favor, suba el reverso del documento de indentidad",
    "updata": "Submáscara",
    "updata_again": "Vuelve a enviarla   "
  },
  "code": {
    "notice": "Notificación     "
  },
  "safe": {
    "title": "Seguridad de la cuenta   ",
    "center": "Centro de seguridad",
    "yysz": "Idioma",
    "ssms": "Modo oscuro   ",
    "gywm": "Sobre nosotros",
    "lgpwd": "Contraseña de acceso ",
    "resetpwd": "Modificar contraseña",
    "paccount": "Su número de teléfono móvil o buzón de correo",
    "reset": "Modificación",
    "ceil": "Cancelar",
    "pcode": "código de verificación",
    "sure": "Confirmar",
    "newPwd": "Restablecer contraseña",
    "ppwd": "Contraseña",
    "reppwd": "Contraseña de nuevo",
    "repwd": "Restablecer contraseña",
    "zpwd": "Contraseña de transacción"
  },
  "met": {
    "open": "Nombre de la cuenta bancaria",
    "bank": "Cuenta bancaria",
    "realname": "Nombre real",
    "save": "Guardar",
    "popen": "Por favor, introduzca el nombre de la cuenta bancaria",
    "pbank": "Por favor, introduzca el número de cuenta",
    "pname": "Por favor, introduzca su nombre real"
  },
  "ads": {
    "tas": "Dirección de retirada de fondos",
    "address": "Dirección",
    "noads": "Todavía no tienes una dirección.",
    "adds": "Dirección",
    "remark": "Marque",
    "cel": "Borrar"
  },
  "jc": {
    "ppwd": "Contraseña"
  },
  "lg": {
    "welcome": "¡Bienvenido! Por favor, inicie sesión",
    "lgtel": "Inicio de sesión móvil",
    "lgeml": "Inicio de sesión por correo electrónico",
    "paccount": "Número de teléfono o correo electrónico",
    "ppwd": "Contraseña",
    "symncz":"Utilice una cuenta demo",
    "ppwd2": "Por favor, confirme su contraseña",
    "pcode": "código de verificación",
    "qsryqm": "Código de invitación",
    "noaccount": "¿Todavía no tiene una cuenta?",
    "register": "Regístrese",
    "phregister": "Inscripción móvil",
    "emregister": "Inscripción por correo electrónico",
    "pphone": "Número de teléfono móvil",
    "ceil": "Cancelar",
    "send": "Obtener CAPTCHA",
    "sure": "ACEPTAR",
    "email": "E-Mail-Addresse",
    "emtest": "Verificación del correo electrónico",
    "pemcode": "código de verificación",
    "ppcode": "Por favor, introduzca su código de verificación",
    "ftpwd": "¿Ha olvidado su contraseña?",
    "ptext": "Su número de teléfono móvil o buzón de correo",
    "yzm": "Código de verificación",
    "mm": "Contraseña",
    "qrmm": "Confirmar contraseña",
    "language":"Idioma",
    "qregister":"Regístrese",
    "lgs":"iniciar sesión",
    "ftpwds":"¿Ha olvidado su contraseña",
    "kjzc": "Contáctenos para un registro rápido",
    "kjzc1": "¿No puede recibir Captcha?",
    "kjzc2": "¡Registro rápido",
    "wyzx": "ya lo se",
    "qtxyxzh": "Importante: Ingrese una dirección de correo electrónico o un número de teléfono móvil válidos, que se pueden utilizar para recuperar su contraseña",
    "next": "Próximo paso"
  },
  "gjrz": {
    "title": "Certificación senior",
    "t1": "1. Se admiten imágenes de menos de 8MB y en formato JPG JPEG o PNG.",
    "t2": "2. Las fotos del documento de identidad deben ser claras y no deben ser modificadas ni bloqueadas. El número del documento fotográfico personal y el nombre del titular del documento deben ser claramente visibles.",
    "t3": "3. Las fotos deben tomarse sin ningún tipo de tocado y se recomienda no incluir el uso de maquillaje. Los rasgos faciales de la foto deben ser claros y reconocibles y sus brazos deben estar completamente expuestos.",
    "t4": "ACEPTAR",
    "bh": "Rechazado",
    "shz": "En revisión",
    "shtg": "Aprobado",
    "sczjz": "Subir fotos del documento de identidad",
    "sczjzmz": "Subir foto del anverso del documento de identidad",
    "sczjbmz": "Subir foto del reverso del documento de identidad",
    "scgrqmz": "Subir documentos de identidad y firma personal"
  },
  "chongzhi": {
    "title": "Depósito",
    "cbjl": "Registro de depósito",
    "t1": "Importe",
    "t2": "Ingrese el importe",
    "t3": "Descripción del bono(Opcional)",
    "t4": "Por favor, introduzca la descripción",
    "t5": "Imagen del vale",
    "t6": "ACEPTAR",
    "t7": "Nombre de la cadena",
    "t8": "Código QR",
    "t9": "Guardar código QR",
    "t10": "Dirección de depósito",
    "t11": "Copiar",
    "zy": "Importante",
    "tips1": "Por favor, no ingrese ningún activo que no sea en moneda local en la dirección mencionada o los activos no se recuperarán",
    "tips2": "1. Compatibilidad de billetera / plataforma: es decir, la red es compatible, si la plataforma de destino no es compatible con su red de retiro, los activos no se pueden recuperar.",
    "tips3": "2. Su red de recarga y la plataforma de destino son la misma, si elige la dirección de destino es la red Ethereum, pero la recarga elige la cadena inteligente TRC20, es posible que no pueda recuperar sus activos digitales.",
    "tips4": "3. Asegúrese de que su dirección y la cantidad sean correctas antes de recargar.",
    "tips5": "Recordatorio: debido al anonimato y la privacidad de la red de bloques, una vez que ingrese la información incorrecta, perderá los activos correspondientes. Comprueba cuidadosamente tu dirección de recarga y la cantidad."
  },
  "tibi": {
    "title": "Retirar",
    "tbjl": "Registro de retiros",
    "t1": "Dirección de retirada de fondos",
    "t2": "Por favor, introduzca la dirección de retiro",
    "t3": "Cantidad a retirar",
    "qsrtbsl": "Por favor, introduzca la cantidad de la moneda de retirada",
    "t4": "Mínimo",
    "t5": "Contraseña de transacción",
    "t6": "Por favor, introduzca la contraseña de la transacción",
    "t7": "Tarifa",
    "t8": "Importe a retirar",
    "t9": "ACEPTAR",
    "sc": "Borrar",
    "bj": "Editar",
    "bq": "Etiqueta (Memo)",
    "qsrbq": "Por favor, introduzca la etiqueta",
    "yhktx": "Retiro con tarjeta bancaria",
    "yhmc": "Nombre del banco",
    "qsryhmc": "Por favor, introduzca el nombre del banco",
    "yhzh": "Cuenta bancaria",
    "qsryhzh": "Por favor, introduzca la cuenta bancaria",
    "gjhkdm": "Código SWIFT",
    "qsrgjhkdm": "Introduzca el código SWIFT",
    "yhdz": "Dirección del banco",
    "qsryhdz": "Ingrese la dirección del banco",
    "skrxm": "Nombre del beneficiario",
    "qsrskrxm": "Ingrese el nombre del beneficiario",
    "skrdh": "Teléfono del beneficiario",
    "qsrskrdh": "Por favor, introduzca el teléfono del beneficiario",
    "skrdz": "Dirección del beneficiario",
    "qsrskrdz": "Por favor, introduzca la dirección del beneficiario"
  },
  "huazhuan": {
    "t4": "Ingrese el importe",
    "ky": "Disponible",
    "t10": "ACEPTAR"
  },
  "banner": {
    "title": "Detalles"
  },
  "download": {
    "t1": "transacciones, en todas partes",
    "xz": "Descarga"
  },
  "xgdlmm": {
    "title": "Modificar contraseña de acceso",
    "zh": "Cuenta",
    "yzm": "Código de verificación",
    "yzmts": "código de verificación",
    "hqyzm": "Obtener CAPTCHA",
    "mm": "Contraseña",
    "qrmm": "Confirmar contraseña",
    "qr": "Confirmar",
    "zhts":"Teléfono móvil o correo electrónico",
    "mmts":"Longitud de la contraseña 6-12 combinaciones alfanuméricas"
  },
  "sztkmm": {
    "title": "Establezca la contraseña de retirada",
    "dlmm": "Contraseña de acceso ",
    "dlmmts": "Introducir la contraseña de acceso",
    "xmm": "Nueva contraseña",
    "mmts": "Longitud de la contraseña 6 dígitos",
    "qrmm": "Confirmar contraseña",
    "qr": "Confirmar",
    "qd": "ACEPTAR",
    "sztkts": "Consejo: Por favor, vaya al Centro de Seguridad para establecer la contraseña de la transacción"
  },
  "rule": {
    "title": "Reglas del evento",
    "title2": "Reglas",
    "title3": "Evento"
  },
  "news": {
    "title": "Mis mensajes",
    "ckxq": "Ver detalles",
    "gg": "Notificación"
  },
  "search": {
    "qx": "Cancelar"
  },
  "wdtg": {
    "wdyqlj": "Mi enlace de invitación",
    "wdyqm": "Mi código de invitación",
    "schbyq": "Generar un banner de invitación",
    "ljtgsy": "Ingresos totales",
    "tkrs": "Número de invitaciones",
    "ljyj": "Comisiones acumuladas",
    "yjmx": "Información de las comisiones",
    "ljyjjl": "Comisión acumulada (USDT)",
    "ljsy": "Ingresos totales",
    "ljyqjl": "Comisiones acumuladas (USTD)",
    "fxd": "Compartir a",
    "bctp": "Guardar imágenes",
    "qx": "Cancelar",
    "t3": "Identificar la imagen o escanearla"
  },
  "bzhl": {
    "title": "Reembolsos en espera",
    "gz": "Reglas",
    "tgdd": "Pedir deposito en garantía (custodia)",
    "zztgdzj": "Fondos en custodia",
    "yjjrsy": "Ingresos del día",
    "ljsy": "Ingresos totales",
    "tgzdd": "Pedido en custodia",
    "cljxcp": "Productos de la campaña estratégica",
    "dbxe": "Límite único",
    "rsyl": "Tasa de rendimiento diaria",
    "zq": "Ciclo",
    "qmr": "Comprar ahora",
    "bbzhzc": "Activos de la cuenta",
    "dd": "Pedidos",
    "buy": "Comprar",
    "jxcp": "Productos destacados",
    "ckdd": "Comprobar pedido",
    "gd": "Más",
    "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
    "qtbz": "Otras monedas"
  },
  "bzhlgm": {
    "qtzq": "Ciclo de 7 días de USDT",
    "rsyl": "Producir(%)",
    "lczq": "Ciclo financiero",
    "dbxe": "Límite único",
    "pxsj": "Calendario de pago de dividendos",
    "mr": "Diario",
    "dqfh": "Retorno a vencimiento",
    "tgzj": "Capital en custodia",
    "tqsh": "Retorno anticipado",
    "yjsy": "Ingresos anticipados (USDT)",
    "kyzc": "Activos disponibles (USDT)",
    "cpjs": "Acerca de nuestros productos",
    "tgje": "Importe de la custodia",
    "qsrtgje": "Por favor, introduzca el importe de la custodia",
    "qb": "Todos",
    "rm": "Comprar ahora",
    "cpzq": "Ciclo del producto",
    "gz": "Conozca las reglas y los intereses"
  },
  "bzhlwdtg": {
    "title": "Estado del pedido",
    "tgz": "En custodia",
    "ywc": "Completado",
    "ysh": "Recuperar",
    "tgje": "Importe de la custodia\/tiempo de la custodia",
    "rsyl": "Tasa de rendimiento diaria",
    "yhl": "Beneficios obtenidos\/días restantes",
    "xdsj": "Tiempo de pedido",
    "sh": "Redención",
    "ddxq": "Detalles del pedido",
    "ddh": "Número de pedido"
  },
  "bzjj": {
    "t1": "Ganar cada día",
    "cpld": "Destacados del producto",
    "scsq": "Depósito y retirada en cualquier momento",
    "pxzq": "Ciclo de dividendos",
    "mtxf": "Distribuir diariamente",
    "hqlx": "Interés actual",
    "zj": "Financiación al 100%",
    "aqbz": "Seguridad",
    "jjrsy": "Ingresos por vacaciones",
    "sybjd": "Ganancias continuas",
    "bjd": "Interrumpido",
    "cgcrh": "Tras un depósito exitoso",
    "dtqx": "Valor del interés en el mismo día",
    "jglz": "Por ejemplo",
    "syjs": "Cálculo de los ingresos",
    "cont2": "Mínimo: 10000U x 0,3%=30U",
    "cont3": "Máximo: 10000U x 0,5%=50U",
    "gywyj": "Acerca de los daños liquidados",
    "wycy": "Quiero participar"
  },
  "zyzs": {
    "title": "Toma de beneficios y stop-loss",
    "zy": "Toma de beneficios",
    "zs": "Stop-loss",
    "qsrzyjg": "Por favor, introduzca un precio de toma de beneficios",
    "qsrzsjg": "Por favor, introduzca un precio de stop-loss",
    "scjg": "Precio de mercado",
    "wxts": "Recordatorio",
    "qr": "Confirmar"
  },
  "bbjy": {
    "mr": "Comprar",
    "mc": "Vender",
    "mai": "Comprar",
    "sell": "Vender",
    "xj": "Límite",
    "sj": "Mercado",
    "pk": "Handicap",
    "jg": "Precio",
    "sl": "Importe",
    "mrl": "Volumen de compra",
    "ss": "Importe",
    "mcl": "Volumen de venta",
    "ky": "Disponible",
    "km": "Disponible",
    "ksell": "Mercado",
    "jye": "Venta",
    "dqwt": "Ordenes abiertas",
    "lswt": "Historial de ordenes",
    "jj": "Información",
    "wtzl": "Total",
    "wtjg": "Precio de la comisión",
    "ycjl": "Volumen de negociación completado",
    "cjjj": "Precio medio de la transacción",
    "cd": "Retirar fondos",
    "xd": "Hacer pedido",
    "ywc": "Completado",
    "ycd": "Retirado",
    "wqcj": "Transacción completada",
    "zx": "Opcional",
    "scjg": "Precio de mercado",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "qx": "Cancelar"
  },
  "hyjy": {
    "mai": "Comprar",
    "sell": "Vender",
    "kc": "Abrir posiciones",
    "pc": "Cerrar posición",
    "cc": "Posiciones",
    "kp": "Cerrar",
    "kpc": "Cerrar corto",
    "kcc": "Posiciones",
    "kkd": "Abrir largo",
    "kpd": "Cerrar largo",
    "kkk": "Abrir corto",
    "xj": "Límite",
    "sj": "Precio de mercado",
    "xjwt": "Orden precio limitado",
    "sjwt": "Precio de mercado",
    "pk": "Handicap",
    "jg": "Precio",
    "sl": "Importe",
    "gg": "Apalacamiento",
    "tzgg": "Ajustar apalancamiento",
    "ggbs": "Apalacamiento",
    "mrl": "Volumen de compra",
    "ky": "Disponible",
    "jye": "Venta",
    "dqwt": "Ordenes abiertas",
    "lswt": "Historial de ordenes",
    "ptwt": "Orden ordinaria",
    "dqwtmr": "Orden actual (Compra)",
    "dqwtmc": "Orden actual (Venta)    ",
    "hywt": "Orden contractual",
    "jj": "Información",
    "wtzl": "Total",
    "wtjg": "Precio de la comisión",
    "ycjl": "Volumen de negociación completado",
    "cjjj": "Precio medio de la transacción",
    "cd": "Retirar fondos",
    "xd": "Hacer pedido",
    "wqcj": "Transacción completada",
    "ywc": "Completado",
    "ycd": "Retirado",
    "zx": "Opcional",
    "scjg": "Precio de mercado",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "mrzd": "Comprar largo",
    "mrpk": "Comprar corto ",
    "mczk": "Vender corto ",
    "mcpd": "Vender largo",
    "mrkdkz": "Comprar al abrir (alcista)",
    "mrpkkz": "Comprar al cierre (alcista)",
    "mckkkd": "Vender al abrir (bajista)",
    "mcpdkd": "Vender al cierre (bajista)",
    "yxhy": "Contrato perpetuo",
    "dc": "Posiciones largas",
    "syl": "Tasa de rendimiento",
    "bzjl": "Tasa de margen",
    "tzbzj": "Ajuste del margen",
    "zyzs": "Toma de beneficios y stop-loss",
    "zhang": "Importe",
    "qblx": "Todos los tipos",
    "qb": "Todos",
    "ccjg": "Precio de la posición",
    "ccsl": "Cantidad de la posición",
    "yk": "Beneficios y pérdidas",
    "ccsj": "Tiempo de la posición",
    "zy": "Toma de beneficios",
    "zs": "Stop-loss",
    "zje": "Importe total",
    "kcs": "Cantidad de la posición abierta",
    "kcjg": "Precio de la posición abierta",
    "ss": "Lotes",
    "hand": "1 lote =",
    "qx": "Cancelar",
    "qr": "Confirmar",
    "qbcd":"Cancelar todos los pedidos"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Orden pendiente",
    "cj": "Transacción",
    "jj": "Información",
    "sj": "Hora",
    "fx": "Dirección",
    "jg": "Precio",
    "sl": "Importe",
    "mr": "Comprar",
    "mc": "Vender",
    "mp": "Oferta",
    "sp": "Venta",
    "slb": "Importe",
    "fhsj": "Hora de salida",
    "fhsl": "Número de edición",
    "bps": "Papel blanco",
    "gw": "Sitio web oficial",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft": "Imagen lateral",
    "zt": "Imagen principal",
    "sdt": "Profundidad",
    "zx": "Opcional",
    "djck": "Click para ver"
  },
  "zhjl": {
    "cbtb": "Depósito y retirada",
    "jymx": "Detalles de la transacción",
    "tgyj": "Comisión de promoción",
    "wwc": "Se acabó",
    "ywc": "Completado"
  },
  "zwsj": {
    "title": "Sin datos"
  },
  "bzxz": {
    "title": "Selección de moneda"
  },
  "jghy": {
    "jghy": "Suspensión",
    "yxhy": "Perpetuo",
    "mz": "Alcista",
    "md": "Bajista",
    "gmj": "Precio de compra",
    "jsj": "Precio de liquidación",
    "xj": "Precio actual",
    "fx": "Dirección",
    "sl": "Importe",
    "jgsj": "Hora de entrega",
    "gb": "Cerrar",
    "jxxd": "Continuar con el pedido",
    "cclb": "Lista de pedidos",
    "zc": "Actualidad",
    "lscc": "Historia",
    "qblx": "Todos los tipos",
    "yk": "Beneficios y pérdidas",
    "ddqr": "Confirmación de pedido",
    "dqsj": "Hora de caducidad",
    "jssj": "Hora de entrega",
    "sy": "Beneficio",
    "tzje": "Precio de la inversión",
    "zdje": "Precio más bajo 0",
    "kyye": "Equilibrio: ",
    "kyye2": "Equilibrio",
    "sxf": "Tarifa: ",
    "sxfl": "Tarifa",
    "jypz": "nombre",
    "jyfx": "Dirección",
    "qrxd": "Confirmar",
    "dqye": "Saldo actual"
  },
  "kjmb": {
    "title": "criptomoneda",
    "gm": "Comprar USDT",
    "wxts": "Recordatorio",
    "copy": "Copiar",
    "ljmb": "Comprar criptomonedas",
    "qx": "Cancelar",
    "gmsl": "Importe de la compra",
    "cssl": "Importe vendido",
    "qsrgmsl": "Por favor, introduzca el importe de la compra",
    "qsrcssl": "Por favor, introduzca el importe de la venta",
    "jg": "Precio",
    "fzcg": "Copiar con éxito"
  },
  "tips": {
    "jymm": "Contraseña de transacción",
    "szjymm": "Establezca la contraseña de retirada",
    "qsrjymm": "Por favor, introduzca la contraseña de la transacción",
    "jymmts": "Por favor, vaya al Centro de Seguridad para establecer la contraseña de la transacción"
  },
  "xyf":{
    "title": "Puntaje de credito",
    "pgsj": "Tiempo de evaluación"
  },
  "dzrz":{
    "title": "Autenticación de dirección",
    "sdddz":"Dirección de la factura de servicios públicos",
    "tpsc": "Carga de imagen de factura",
    "ts": "Recordatorio: debe completar la información de la dirección y enviar la factura de servicios públicos o la factura de la dirección de banda ancha",
    "tips":"debe completar la información de la dirección y enviar la factura de servicios públicos o la factura de la dirección de banda ancha",
    "qsczdtp":"Carga de imagen de factura"
  },
  "newReg":{
    "sjh": "teléfono móvil",
    "yx": "Email",
    "yqm": "Código de invitación",
    "yqm2": "Código de invitación (opcional)",
    "cjzh": "Crear una cuenta",
    "sysjhzyx": "Número de móvil / registro de correo electrónico",
    "sj": "Móvil",
    "yhxy": "&lt;Acuerdo de usuario&gt;",
    "yhxy2": "He leído y acepto el &lt;Acuerdo de usuario&gt;"
  },
  "mbwt":{
    "title": "Cuestiones de seguridad",
    "mbwt": "Cuestiones de seguridad",
    "qtxda": "Por favor, responda a la pregunta",
    "qsrxmm": "Ingrese una nueva contraseña",
    "sydqmmcz": "Restablecer con la contraseña actual",
    "zhmm": "Problemas de seguridad Recuperar contraseña",
    "ysz": "Configurar",
    "tg": "Ignorar",
    "tj": "Enviar",
    "zyts": "Importante:",
    "zytsCont": "No revele la respuesta secreta y el código de verificación, y tenga en cuenta el problema de seguridad, que lo ayudará a recuperar su contraseña."
  },
  "xbsg":{
    "title": "Moneda nueva",
    "wdsg": "Detalles",
    "scts": "Días de encierro: ",
    "sy": "restante",
    "ljsg": "Suscríbase ahora",
    "ysk": "Vendido",
    "xzjdy": "Suscríbase ahora",
    "dy": "Suscribir",
    "fxjg": "precio de emisión",
    "fxl": "Circulación",
    "ssrq": "Fecha de cotización",
    "yxqx": "Período de validez",
    "qsrsl": "Por favor ingrese la cantidad",
    "syl": "restante",
    "sgrq": "suscribir",
    "sgsl": "Monto",
    "bz": "Moneda",
    "yebz": "Saldo de USDT insuficiente",
    "tgsl": "Cantidad de pases",
    "shz": "bajo revisión",
    "wtg": "No pasó",
    "ytg": "aprobado"
  },
  "wydb":{
    "title": "Pedir prestado",
    "db": "Pedir prestado",
    "dbz": "Pedir prestado",
    "jl": "registro",
    "jdzq": "Período (días)",
    "qhk": "Volver a pagar",
    "ljdb": "Acumulativo (usdt)",
    "dhkbs" :"pago pendiente",
    "jkje": "cantidad (usdt)",
    "qsrje": "Por favor ingrese la cantidad",
    "rll": "Tasa de interés diaria",
    "hkfs": "Reembolso",
    "dqych": "Caducado",
    "lx": "Interesar",
    "fkjg": "Prestador",
    "tpsc": "Préstamo de crédito (carga de imagen)",
    "fwxx": "Información de vivienda",
    "srzm": "Comprobante de ingresos (relación laboral)",
    "yhmx": "Extracto de cuenta",
    "zjz": "foto de identificación",
    "yd": "He leído y estoy de acuerdo",
    "xy": "Solicitar un acuerdo de préstamo",
    "sqdb": "solicitar cadenas de préstamo",
    "gb": "cierre",
    "qd": "OK",
    "ts": "Por favor marque Solicitar un acuerdo de préstamo",
    "dbjl": "registro",
    "hkhth": "Código de orden",
    "wsh": "sin revisar",
    "yfk": "Préstamo",
    "sqrq": "tiempo de aplicación",
    "zq": "ciclo",
    "dbsl": "Monto",
    "zhke": "Pago total",
    "yhkxq": "Detalles de reembolso",
    "bqyhk": "Reembolsable en el período actual(USDT)",
    "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue primero y luego pague",
    "bj": "Principal",
    "jie": "Pedir prestado",
    "ljhk": "pagar inmediatamente",
    "qcz": "Depositar",
    "yebzqxcz": "Saldo insuficiente, recargue primero y luego pague",
    "znj": "cargo del pago atrasado",
    "yqts": "Dias atrasados"
  },
  "hkxq":{
    "dd":"Pedido",
    "fzhkdz":"Copia la dirección de pago",
    "hkxq": "Detalles de reembolso",
    "zlx": "interés total",
    "zhk": "reembolsos totales",
    "hkjg": "agencia de pago",
    "qschkpz": "Cargue el certificado de reembolso",
    "hkpz": "certificado de reembolso"
  },
  "bbjyNew":{
    "jylx": "Tipos de",
    "jyze": "Cantidad"
  },
  "indexNew":{
    "title": "Agregue TokenSwap a la interfaz principal",
    "t1": "Acceso rápido a la experiencia de pantalla completa",
    "t2": "Haga clic en la barra de herramientas a continuación",
    "t3": "y seleccione",
    "t4": "Añadir a la pantalla principal",
    "t5": "Agregar a la experiencia de escritorio la versión completa de TokenSwap",
    "t6": "Zu Favoriten hinzufügen",
    "t7": "Finde auf Seite"
  },
  "bind":{
    "title": "Verificacion de Email",
    "ybd": "Unido",
    "wbd": "Sin consolidar",
    "yrz": "Verificado",
    "wrz": "No verificado",
    "ts": "Para proteger su cuenta, se recomienda vincular una dirección de correo electrónico",
    "qsryxdz": "E-Mail-Addresse"
  },
  "status":{
    "statusText": ['falla','Esperando ser procesado','éxito'],
 },
 "tipsNew":{
   "wjmmts": "Recuperar contraseña por código de verificación",
   "qscpztp": "Carga de la imagen del cupón",
   "emailgsts": "Por favor introduzca una dirección de correo electrónico válida",
   "telgsts": "El número de teléfono móvil es incorrecto.",
   "lcmmbyz": "Bitte bestätigen Sie Ihr Passwort",
   "zdsl": "Mínimo ",
   "sldydy": "Cantidad mayor o igual a",
   "zxtzsl": "Mínimo ",
   "ddz": "Esperando",
   "xs": "Hora",
   "min": "Monto minimo ",
   "max": "Cantidad máxima ",
   "yebz": "Saldo insuficiente",
   "qsrss": "Por favor ingrese el lote",
   "zdss": "Lotes mínimos",
   "yjj": "rechazado",
   "shz": "redención",
   "zwkfcz": "Esta moneda aún no está abierta para recarga",
   "jiaoge": "Entrega",
    "zhang": "levantarse",
    "die": "otoño",
    "cjxnzh": "Crear cuenta virtual"
 },
 "langNew2":{
  "flzq": "Centro de recompensas",
  "qdjl": "Iniciar sesión recompensa",
  "mrqdjl": "Recompensa de inicio de sesión diario",
  "qd": "Iniciar sesión",
  "yqd": "Registrado",
  "hdgz": "Reglas del evento",
  "qdjl2": "registro de entrada",
  "qdcg": "Iniciar sesión con éxito",
  "yhd": "Adquirido",
  "lq": "Recibir",
  "dyt": "Día 1",
  "det": "Día 2",
  "dst": "Día 3",
  "dsit": "Día 4",
  "dwt": "Día 5",
  "dlt": "Día 6",
  "dqt": "Día 7",
  "jxz": "en progreso"
},
"langNew":{
  "kp": "Apertura",
  "zuoshou": "recibido ayer",
  "zg": "más alto",
  "zd": "más bajo",
  "dqjg": "Precio actual",
  "pcjg": "Precio de cierre",
  "gd": "orden pendiente",
  "gdj": "Precio del pedido pendiente",
  "gdjg": "Precio del pedido pendiente",
  "xfbzj": "Depósito de seguridad requerido: ",
  "ksrfw": "Rango de entrada disponible: ",
  "shou": "Lotes",
  "fdjyk": "ganancias y pérdidas netas flotantes",
  "pcsl": "Cantidad de cierre",
  "cx": "revocar",
  "qrpc": "Confirmar para cerrar la posición",
  "sx": "filtrar",
  "cz": "reiniciar",
  "zdl": "sabía",
  "kccg": "¡Abrió con éxito una posición!",
  "xzfx": "elegir dirección",
  "lx": "tipo",
  "xgcc": "modificar posición",
  "szzyzs": "Establecer stop loss y stop loss",
  "szhb": "criptomoneda",
  "gjs": "Metal",
  "yy": "Crudo",
  "jy": "Comercio",
  "jmhb": "criptomoneda",
  "gdsj": "Tiempo de pedido pendiente",
  "gdsl": "Cantidad de pedido pendiente",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/es.js